import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TwoFactorVerifyForm from '../../components/application/authentication/TwoFactorVerifyForm';
import { flashMessageSelector, flashOpenSelector, flashTypeSelector } from '../../selectors/application';
import { closeFlash } from '../../actions/global';
import {
    twoFactorCodeSelector,
    twoFactorSubmittingSelector,
    twoFactorErrorSelector,
    twoFactorRequiresVerificationSelector,
    twoFactorRecoveryCodeSelector,
    twoFactorUseRecoveryCodeSelector
} from '../../selectors/authentication';
import {
    inputTwoFactor,
    submitLoginWith2FA,
    submitLoginWithRecoveryCode,
    toggleRecoveryMode,
    cancelTwoFactor
} from '../../actions/twoFactor';

class TwoFactorVerify extends Component {
    _onSubmit = () => {
        this.props.submitLoginWith2FA(this.props.code);
    };

    _onRecoveryCodeSubmit = () => {
        this.props.submitLoginWithRecoveryCode(this.props.recoveryCode.toUpperCase());
    };

    _onInput = (value, key) => {
        // Only allow numeric input for TOTP code
        const numericValue = value.replace(/\D/g, '');
        this.props.inputTwoFactor(numericValue, key);
    };

    _onRecoveryCodeInput = (value, key) => {
        // Allow alphanumeric input for recovery code, convert to uppercase
        const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        this.props.inputTwoFactor(cleanValue, key);
    };

    _onToggleRecoveryMode = () => {
        this.props.toggleRecoveryMode();
    };

    _onCancel = () => {
        this.props.cancelTwoFactor();
    };

    render() {
        return (
            <TwoFactorVerifyForm
                code={this.props.code}
                recoveryCode={this.props.recoveryCode}
                useRecoveryCode={this.props.useRecoveryCode}
                onInput={this._onInput}
                onRecoveryCodeInput={this._onRecoveryCodeInput}
                onSubmit={this._onSubmit}
                onRecoveryCodeSubmit={this._onRecoveryCodeSubmit}
                onToggleRecoveryMode={this._onToggleRecoveryMode}
                onCancel={this._onCancel}
                loading={this.props.loading}
                errorText={this.props.error}
            />
        );
    }
}

const mapStateToProps = state => ({
    requiresVerification: twoFactorRequiresVerificationSelector(state),
    code: twoFactorCodeSelector(state),
    recoveryCode: twoFactorRecoveryCodeSelector(state),
    useRecoveryCode: twoFactorUseRecoveryCodeSelector(state),
    loading: twoFactorSubmittingSelector(state),
    error: twoFactorErrorSelector(state),
    flashMessage: flashMessageSelector(state),
    flashOpen: flashOpenSelector(state),
    flashType: flashTypeSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            inputTwoFactor,
            submitLoginWith2FA,
            submitLoginWithRecoveryCode,
            toggleRecoveryMode,
            cancelTwoFactor,
            closeFlash
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorVerify);
